import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { OpenLinkById } from '../../services/openlinkbyid';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-search-content',
  templateUrl: './search-content.component.html',
  styleUrls: ['./search-content.component.css']
})
export class SearchContentComponent implements OnInit {

  Searchterm:string;
  area:string;
  topicId:string;
  topicTitle:string;
  subtopicTitle:string;
  subtopicId:string;
  sectionTitle:string;
  topic:string="";
  @Input() BreadCrumPath:string="";
  @Input() ContentLink:string="";
  topicResult:any;
  @Output() myEvent = new EventEmitter<string>();
  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, private openlink: OpenLinkById,  private route: Router) {
  }

  ngOnInit(): void {
    this.Searchterm = localStorage.getItem("ElasticSearchTerm");
    this.commonDataService.elasticSearchTopicData.subscribe(topicData=>{
      if(topicData){
        this.graphQlService.GetSubopicSearchResults(topicData).subscribe(data => {
          if(data){
            this.topicResult = data.hits.hitsList;
            // this.GetDistinctSubtopicRecords();
            this.topicResult.forEach(res=>{
              res.source.url = res.source.url + "/" + res.source.topicId + "-" + res.source.subtopicId + "-" + res.source.paragraphId;
            });
            let topicFirstData = this.topicResult[0].source;
            this.area = topicFirstData.area;
            this.topic = topicFirstData.topicId + " " + topicFirstData.topicTitle;
          }
          })
      }
    })
  }
  subtopicsRes:any=[];
  GetDistinctSubtopicRecords(){
    let count=0;
    this.topicResult.forEach(element => {
      if(count==0){
        this.subtopicsRes.push(element);
        count++;
      }
      else{
        count++;
        var subtopicExists=this.subtopicsRes.filter(x=>x.source.subtopicId==element.source.subtopicId && x.source.sectionId==element.source.sectionId)
        if(subtopicExists.length==0){
          this.subtopicsRes.push(element);
        }
      }
    });
    
    this.topicResult=this.subtopicsRes;
  }
  openLinkById(event) {
    event.preventDefault();
    this.openlink.openLinkById(event);
     this.myEvent.emit();
  }
  navigateToContent() {
    this.route.navigateByUrl("94389/2147483597/presentation/status");
    this.myEvent.emit();
  }
}
